<template>
  <div class="container-dark" id="sponsorenwand">
    <div class="container">
      <h1 class="headline-light mb-1 bebas">Unsere Sponsorenwand 2025/2026</h1>
      <p class="text-light mb-4">Wir danken unseren Sponsoren & Supportern für die Unterstützung. Ein großes Netzwerk, das gemeinsam viel erreichen kann! Nur mit Euch ist das alles möglich und umsetzbar. DANKE!</p>
      <div class="partner-images">
        <div class="logo">
          <img
            src="../assets/sponsorenwand.jpg"
            alt="Logo von Stauder"
          />
        </div>      
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
};
</script>

<style lang="scss" scoped>
img {
    width: 100%;
}
@media (max-width: 700px) {
    #sponsorenwand .container {
        padding: 0px;
    }
}
</style>
